module.exports = __webpack_public_path__ + "static/media/bg-onboarding.a434e0a9.png";